module.exports = __webpack_public_path__ + "img/serive2.92a59f18.jpg";